// extracted by mini-css-extract-plugin
module.exports = {"cast":"Cast_cast__o3JDM","title":"Cast_title__2qIuE","content":"Cast_content__22j4o","cards":"Cast_cards__2og72","card":"Cast_card__6kowr","no-casts":"Cast_no-casts__2aDMO"};